import type { HTMLAttributes, ReactNode } from "react";

import { cn } from "@/lib/utils";

export interface ULThemePageLayoutProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * The content of the layout.
   */
  children: ReactNode;
  /**
   * Optional class names for additional styling or overriding default styles.
   */
  className?: string;
}

const ULThemePageLayout = ({
  children,
  className,
  ...rest
}: ULThemePageLayoutProps) => {
  // min-h-dvh (não min-h-screen/100vh): no iOS Safari, 100vh é o viewport GRANDE
  // (ignora as barras do navegador), o que empurra/corta o card em telas baixas
  // como iPhone 13. dvh = altura visível real. overflow-x-clip protege contra
  // overflow horizontal (os orbs da aurora já têm overflow:hidden próprio),
  // deixando o eixo vertical rolar normalmente quando o conteúdo não cabe.
  // Padding vertical reduzido no mobile pra não estourar a altura.
  const themedStyles =
    "relative flex items-center min-h-dvh overflow-x-clip px-6 py-8 sm:py-16 justify-page-layout bg-(color:--ul-theme-page-bg-background-color) bg-(image:--ul-theme-page-bg-background-image-url)";
  return (
    // role="main": a tela inteira é o único landmark principal da página ACUL.
    <div role="main" className={cn(themedStyles, className)} {...rest}>
      {/* Aurora dourada — fundo animado, decorativo */}
      <div className="vault-aurora" aria-hidden="true">
        <span className="vault-aurora__orb vault-aurora__orb--1" />
        <span className="vault-aurora__orb vault-aurora__orb--2" />
        <span className="vault-aurora__orb vault-aurora__orb--3" />
      </div>
      <div className="relative z-10">{children}</div>
    </div>
  );
};

export default ULThemePageLayout;
